/** One chip of a filter: what it filters on, and the server's count for it where one is published. */
export interface SendFilterChipOption {
  key: string;
  label: string;
  /** The server's count for the chip, when it publishes one that counts only what the chip filters. */
  count?: number;
}

/** Switches one key in a filter selection, returning a new set so state updates are detected. */
export const toggled = (selection: ReadonlySet<string>, key: string): ReadonlySet<string> => {
  const next = new Set(selection);
  if (next.has(key)) {
    next.delete(key);
  } else {
    next.add(key);
  }
  return next;
};
